import { render, staticRenderFns } from "./recordByVoiceHskk.vue?vue&type=template&id=6a44711c&scoped=true"
import script from "./recordByVoiceHskk.vue?vue&type=script&lang=js"
export * from "./recordByVoiceHskk.vue?vue&type=script&lang=js"
import style0 from "./recordByVoiceHskk.vue?vue&type=style&index=0&id=6a44711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44711c",
  null
  
)

export default component.exports